import { useContext, useEffect } from 'react';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';
import { SchedulerContext } from '../../SchedulerContext';

const useStyles = makeStyles<void, 'minWidthAdjustment'>()(
  (theme, _params, classes) => ({
    weekViewTimeTableLayoutCustom: {
      height: '100%',
      [`&.${classes.minWidthAdjustment}`]: {
        [theme.breakpoints.down('sm')]: {
          minWidth: '0px !important',
        },
      },

      backgroundColor: theme.palette.common.white,
    },
    minWidthAdjustment: {},
  })
);

export const WeekViewTimeTableLayoutCustom = (
  props: WeekView.TimeTableLayoutProps
) => {
  useEffect(() => {
    if (document.getElementsByClassName('Label-text')[4] != null) {
      let element = document.getElementsByClassName('Label-text')[4];
      element.scrollIntoView();
    }
  }, []);

  const schedulerContext = useContext(SchedulerContext);
  const { classes, cx } = useStyles();
  return (
    <WeekView.TimeTableLayout
      {...props}
      className={cx(classes.weekViewTimeTableLayoutCustom, {
        [classes.minWidthAdjustment]: !schedulerContext.overView,
      })}
    ></WeekView.TimeTableLayout>
  );
};
